import { useMatches } from 'react-router-dom'

import type { TermLabel } from '@/hooks/useTerm'

/** Per-route metadata the shell reads — the page title bar comes from here. */
export interface RouteHandle {
  title: TermLabel
  subtitle?: string
  /**
   * `wide` drops the content max-width; `board` also makes the page own its own
   * height, for screens that scroll inside themselves instead of with the page.
   */
  layout?: 'default' | 'wide' | 'board'
}

/** The innermost matched route that declares a title. */
export function usePageMeta(): RouteHandle | null {
  const matches = useMatches()

  for (let i = matches.length - 1; i >= 0; i--) {
    const handle = matches[i]?.handle as RouteHandle | undefined
    if (handle?.title) return handle
  }
  return null
}
